/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// import * as AppPropTypes from '../../lib/PropTypes';

import Menu from './Menu';

import styles from '../../../styles/partials/header-side-menu.scss';

const propTypes = {
    onClickItem: PropTypes.func.isRequired,
    menuOpened: PropTypes.bool.isRequired,
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const HeaderMenu = ({ onClickItem, menuOpened, className }) => {
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.opened]: menuOpened,
                    [className]: className !== null,
                },
            ])}
        >
            <div className={styles.inner}>
                <div className={styles.top}>Finding Menu</div>

                <Menu onClickItem={onClickItem} className={styles.menu} />
            </div>
        </div>
    );
};

HeaderMenu.propTypes = propTypes;
HeaderMenu.defaultProps = defaultProps;

export default HeaderMenu;
